import { Button } from '@/shared/components/Button';
import { Card, CardBody } from '@/shared/components/Card';
import TextField from '@/shared/components/form/Fields/TextField';
import { colorTextAdditional } from '@/utils/palette';
import { Col, Row } from 'react-bootstrap';
import styled from 'styled-components';

const GpuOneFilterSection = ({
	filters,
	onFilterChange,
	onSortChange,
	onClearFilters,
}) => {
	return (
		<FilterCard>
			<CardBody>
				<FilterHeader>
					<h5>Filters</h5>
				</FilterHeader>
				<FilterForm>
					<Row className="g-3">
						<Col md={3}>
							<TextField
								placeholder="Filter by machine name..."
								value={filters.machineName || ''}
								onChange={e => onFilterChange('machineName', e.target.value)}
								variant="standard"
							/>
						</Col>
						<Col md={3}>
							<TextField
								placeholder="Filter by vendor..."
								value={filters.systemVendor || ''}
								onChange={e => onFilterChange('systemVendor', e.target.value)}
								variant="standard"
							/>
						</Col>
						<Col md={3}>
							<TextField
								placeholder="Filter by product..."
								value={filters.systemProduct || ''}
								onChange={e => onFilterChange('systemProduct', e.target.value)}
								variant="standard"
							/>
						</Col>
						<Col md={3}>
							<TextField
								placeholder="Filter by status..."
								value={filters.machineStatus || ''}
								onChange={e => onFilterChange('machineStatus', e.target.value)}
								variant="standard"
							/>
						</Col>
						<Col md={3}>
							<TextField
								placeholder="Filter by OS..."
								value={filters.deployedOS || ''}
								onChange={e => onFilterChange('deployedOS', e.target.value)}
								variant="standard"
							/>
						</Col>
						<Col md={12}>
							<FilterButtonContainer>
								<Button variant="primary" size="sm" onClick={onClearFilters}>
									Clear All
								</Button>
							</FilterButtonContainer>
						</Col>
					</Row>
				</FilterForm>
			</CardBody>
		</FilterCard>
	);
};

// Styled Components
const FilterCard = styled(Card)`
	margin-bottom: 30px;
`;

const FilterHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 15px;
	padding-bottom: 10px;

	h5 {
		margin: 0;
		color: ${colorTextAdditional};
		font-weight: 600;
	}
`;

const FilterForm = styled.div`
	margin-top: 15px;
`;

const FilterButtonContainer = styled.div`
	display: flex;
	float: right;
	align-items: flex-end;
	height: 100%;
	padding-bottom: 8px;
`;

export default GpuOneFilterSection;
